var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72145 0L0 4.18702L6.72145 8.37403L13.444 4.18702L20.1655 8.37403L26.8869 4.18702L20.1655 0L13.444 4.18702L6.72145 0Z",
    fill: "#0061FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72145 16.7481L0 12.5611L6.72145 8.37402L13.444 12.5611L6.72145 16.7481Z",
    fill: "#0061FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4443 12.5611L20.1658 8.37402L26.8872 12.5611L20.1658 16.7481L13.4443 12.5611Z",
    fill: "#0061FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4443 22.3308L6.72168 18.1438L13.4443 13.9568L20.1657 18.1438L13.4443 22.3308Z",
    fill: "#0061FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.0db5eebed00b5276c1ef32424e8d23b9.svg";
export { ForwardRef as ReactComponent };